import React from "react";

export default function Handelsbetingelser() {
  return (
    <div className="bg-[#F7F3EC] min-h-screen" data-testid="handelsbetingelser-page">
      <section className="py-16 md:py-24 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="label-tag mb-4">Juridisk</div>
        <h1 className="font-heading text-4xl md:text-5xl text-graphite mb-10 leading-tight">Handelsbetingelser.</h1>
        <div className="prose prose-lg max-w-none text-graphite/85 leading-relaxed space-y-6">
          <p>
            Disse handelsbetingelser gælder for aftaler om biludlejning, langtidsleje og bilsalg indgået med Mahasa. Ved at indgå en aftale med os accepterer du betingelserne nedenfor.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">1. Virksomhedsinformation</h2>
          <p>
            Aftalen indgås med Mahasa. CVR-nummer og kontaktinformation kan findes i bunden af denne side eller på vores kontaktside.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">2. Biludlejning</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Lejer skal være fyldt 21 år og have gyldigt kørekort.</li>
            <li>Bilen må kun benyttes inden for Danmarks grænser, medmindre andet er skriftligt aftalt.</li>
            <li>Bilen skal afleveres i samme stand som ved afhentning, med samme brændstofniveau.</li>
            <li>Skader og bøder pålagt under lejeperioden er lejers ansvar.</li>
            <li>Forsinket aflevering kan medføre ekstra gebyrer.</li>
          </ul>

          <h2 className="font-heading text-2xl text-graphite pt-6">3. Langtidsleje</h2>
          <p>
            Langtidsleje aftales individuelt med minimum én måneds binding. Betalingsbetingelser, kilometerloft og opsigelsesvarsler fremgår af den underskrevne aftale.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">4. Bilsalg</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Alle biler sælges som beset, medmindre andet er skriftligt aftalt.</li>
            <li>Reklamationsret følger gældende dansk lovgivning for brugte biler (12 måneder ved forbrugerkøb).</li>
            <li>Ejerskifte og overdragelse af nummerplader sker via Motorregistret.</li>
            <li>Restbetaling skal være indgået på Mahasas konto inden bilen udleveres.</li>
          </ul>

          <h2 className="font-heading text-2xl text-graphite pt-6">5. Priser og betaling</h2>
          <p>
            Alle priser er angivet i danske kroner inklusive moms, hvor andet ikke er angivet. Betaling kan ske via bankoverførsel, betalingskort eller MobilePay.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">6. Fortrydelse</h2>
          <p>
            Køb af brugte biler indgået på vores forretningsadresse er ikke omfattet af fortrydelsesretten. Ved fjernsalg gælder den almindelige 14-dages fortrydelsesret efter forbrugeraftaleloven.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">7. Ansvar</h2>
          <p>
            Mahasa kan ikke gøres ansvarlig for indirekte tab eller følgeskader. Direkte erstatning er begrænset til det beløb, kunden har betalt under den konkrete aftale.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">8. Tvister</h2>
          <p>
            Eventuelle uoverensstemmelser søges først løst ved direkte dialog. Lykkes dette ikke, afgøres tvister efter dansk ret ved den almindelige domstol i den retskreds, hvor Mahasa har hjemsted.
          </p>

          <p className="text-sm text-graphite/55 pt-8 border-t border-[#E5DED1]">Senest opdateret: {new Date().toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" })}</p>
        </div>
      </section>
    </div>
  );
}
